import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { HedaCoreUtilModule } from '@heda/core-util';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TerminologyLibModule } from 'app/mdm/terminology-lib/terminology-lib.module';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { HedaCoreHospitalUiModule } from '@heda/core-hospital-ui';
import { ObservationDefinitionLibModule } from 'app/mdm/lib/observation-definition/observation-definition-lib.module';
import { SnomedTranslationListComponent } from 'app/mdm/terminology/snomed/containers/snomed-translation-list.component';
import { SnomedViewComponent } from 'app/mdm/terminology/snomed/containers/snomed-view.component';
import { SnomedMdmService } from 'app/mdm/terminology/snomed/services/snomed-mdm.service';

export const SNOMED_ROUTES: Routes = [
  { path: '', component: SnomedViewComponent },
  { path: 'view/:id', component: SnomedViewComponent },
  { path: 'translations', component: SnomedTranslationListComponent },
];

@NgModule({
  imports: [
    HedaCoreHospitalUiModule,
    HedaCoreUtilModule,
    FormsModule,
    RouterModule,
    TerminologyLibModule,
    TranslateModule,
    ReactiveFormsModule,
    CommonModule,
    ObservationDefinitionLibModule,
  ],
  declarations: [SnomedTranslationListComponent, SnomedViewComponent],
  exports: [SnomedTranslationListComponent, SnomedViewComponent],
  providers: [SnomedMdmService],
})
export class SnomedModule {}
